let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("31wTJ")).then(() => parcelRequire('fBK8V'));